<template>
  <div class="line"></div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .line {
    width: calc(100% - 30px);
    background: #666666;
    opacity: 0.12;
    height: 1px;
    margin: 30px auto;
  }
</style>